import { useAuth } from '.';
export var useRoles = function (orgId) {
    var activeOrgUserRoles;
    var authData = useAuth();
    var profile = authData.getUserProfile();
    function processOrgRoles() {
        var _a;
        var userRolesByOrg = {};
        (_a = profile.roles) === null || _a === void 0 ? void 0 : _a.forEach(function (role) {
            var org = role.organization;
            if (!userRolesByOrg[org]) {
                userRolesByOrg[org] = {};
            }
            userRolesByOrg[org][role.namedRole] = true;
        });
        activeOrgUserRoles = userRolesByOrg[orgId] || {};
    }
    var getTargetsByRole = function (adminRole) {
        var _a;
        return (_a = profile.roles) === null || _a === void 0 ? void 0 : _a.filter(function (role) { return role.namedRole === adminRole && role.organization === orgId; }).map(function (role) { return role.target; });
    };
    var isUserOrgAdmin = function () {
        return !!(activeOrgUserRoles && activeOrgUserRoles.ORG_ADMIN);
    };
    var isUserSupportDelegate = function () {
        return !!(activeOrgUserRoles && activeOrgUserRoles.SUPPORT_ADMIN);
    };
    var isUserProductSupportAdmin = function () {
        return !!(activeOrgUserRoles && activeOrgUserRoles.PRODUCT_SUPPORT_ADMIN);
    };
    processOrgRoles();
    return {
        getTargetsByRole: getTargetsByRole,
        isUserOrgAdmin: isUserOrgAdmin,
        isUserSupportDelegate: isUserSupportDelegate,
        isUserProductSupportAdmin: isUserProductSupportAdmin,
    };
};
